import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',[_c(VTextField,{attrs:{"label":_vm.label,"clearable":"","rules":_vm.required ? _vm.userNameRules : [],"name":"userName","readonly":""},on:{"click":_vm.showDialog,"click:clear":_vm.onClickClear},model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}})],1),_c('UserSelectDialog',{ref:"userSelectDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }